//import styles from './OrderEngineComment.module.css'
import styles from '../CommonCss/OrderEngineCommon.module.css'

import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import WaitLoader from "../../../WaitLoader/WaitLoader";
import Slide from "../../../Slider/Slide";

interface OrderEngineTarifCardPropsInt
{
    tarifId:string
    regionId:number
    macroRegionId:number
    onClose: ()=>void
    onSuccess?: ()=>void
}

export default function OrderEngineTarifCard({tarifId,regionId,onSuccess,onClose,macroRegionId}:OrderEngineTarifCardPropsInt){

    const tarifCardState = useRef<ErrorLineItemRef>(null)
    const [cardData, setCardData] = useState({})

    const tarifData = useRef({
        regionId:-1,
        macroRegionId: -1,
        tarifId:""
    })
    const [ldrTarif,rsTarif,exTarif] = useApiQuery("/tarif/def","post",tarifData);


    useEffect(()=>{
        if(tarifId) loadTarif()
    },[tarifId])


    const loadTarif = () =>{

        tarifData.current.regionId = regionId
        tarifData.current.macroRegionId =  macroRegionId
        tarifData.current.tarifId = tarifId
        exTarif().then((e)=>{
            if(e?.success)
            {
                if(e?.payload && Array.isArray(e?.payload) && e?.payload?.length > 0 )
                {
                    const pr = e?.payload[0]
                    setCardData(pr)
                    return
                }
                return;
            }
            if(tarifCardState.current)tarifCardState.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)

        }).catch((e)=>{
            if(tarifCardState.current)tarifCardState.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
        })

    }

    return(
        <ModalWindow>
            <MainFormTemplate title={`Карточка тарифа`} maxWidth={"500px"} background={"white"} onClose={onClose}>
                <div className={"d-flex align-items-center justify-content-center my-3"}>
                    <Slide
                        item={cardData}
                        key={0}
                        showConnect={false}
                    ></Slide>
                </div>
                <ErrorLineItem ref={tarifCardState} ></ErrorLineItem>
                <div className={styles.actCont}>
                    <WaitLoader loading={ldrTarif } api={rsTarif} onlyLoading={true}>

                    </WaitLoader>

                </div>



            </MainFormTemplate>
        </ModalWindow>
    )
}